// shared/services/component-utils.service.ts

import { EventEmitter, Injectable } from '@angular/core';
import { customComponentListener } from '@core/types/types';

@Injectable({ providedIn: 'root' })
export class ComponentUtilsService {
  attachListeners<T>(target: T, listeners: customComponentListener[] = []) {
    listeners.forEach((listener) => {
      const emitter = (target as any)[listener.event] as EventEmitter<any>;
      if (emitter) {
        emitter.subscribe((data: any) => listener.action(data));
      }
    });
  }

  getQueryParams(url: string) {
    const queryParams = new URLSearchParams(url.split('?')[1]);
    const params: { [key: string]: string } = {};
    queryParams.forEach((value, key) => {
      params[key] = value;
    });
    return params;
  }

  getUrl(url: string, asArray: boolean): string[] | string {
    return asArray ? url.split('?')[0].split('/') : url.split('?')[0];
  }
}
